/**
 * JWT Utility Functions
 * Simple JWT decoding without verification (client-side only)
 * For verification, always use the backend
 */

/**
 * Decode JWT token and extract payload
 * @param token JWT token string
 * @returns Decoded payload or null if invalid
 */
export const decodeJWT = (token: string | null): any | null => {
  if (!token) return null;

  try {
    // JWT format: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Decode payload (second part)
    const payload = parts[1];
    // Replace URL-safe base64 characters
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    // Add padding if needed
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    
    // Decode base64
    const decoded = atob(padded);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
};

/**
 * Extract userId from JWT token
 * @param token JWT token string
 * @returns userId or null if not found
 */
export const getUserIdFromToken = (token: string | null): string | null => {
  const payload = decodeJWT(token);
  if (!payload) return null;
  
  // Check common userId field names
  return payload.userId || payload.user_id || payload.id || payload.sub || null;
};

